import { List } from "antd";
import DidItem from "./DidItem";
import { Did } from "../../../interfaces/Did.type";

const DidsList = (
    { dids, setCurrentDid ,selectedDid}:
    {
        dids: Partial<Did>[],
        setCurrentDid: Function
        selectedDid: Did | null
    }) => {
    return (
        <List
            itemLayout="horizontal"
            dataSource={dids as Did[]}
            renderItem={(did: Did) => (
                <DidItem
                    did={did}
                    selectedDid={selectedDid}
                    onClick={() => setCurrentDid(did)}
                />
            )}
        />
    )

}

export default DidsList